import { DialogData } from "../_models/dialogData";

export class AppSettings {
  public static US_STATES = [
    "AK",
    "AL",
    "AR",
    "AZ",
    "CO",
    "CT",
    "DE",
    "FL",
    "GA",
    "HI",
    "IA",
    "ID",
    "IL",
    "IN",
    "KS",
    "KY",
    "LA",
    "MA",
    "MD",
    "ME",
    "MI",
    "MN",
    "MO",
    "MS",
    "MT",
    "NC",
    "ND",
    "NE",
    "NH",
    "NJ",
    "NM",
    "NV",
    "NY",
    "OH",
    "OK",
    "OR",
    "PA",
    "PR",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VA",
    "VT",
    "WA",
    "WI",
    "WV",
    "WY",
  ];
  public static HelpInfo: { id: number; helper: DialogData }[] = [
    {
      id: 0,
      helper: {
        title: "Product List",
        content:
          "<p>Choose Category – Products are separated into categories. Environmental, Health & Safety, etc.</p>",
      },
    },
    {
      id: 1,
      helper: {
        title: "Release Notes",
        content: `<p>Keeps you up to date on current changes and what is going on in the industry. Release notes are published with every update and contain up to 3 sections.</p>
        <ul><li><b>New and noteworthy</b>: Overview of key changes found in current updated version.</li>
        <li><b>Highlights of this release</b>: What and where changes have occurred.</li>
        <li><b>Did you know</b>: Information on current industry subjects and issues.</li></ul>`,
      },
    },
    {
      id: 2,
      helper: {
        title: "Format",
        content: `<ul><li>PDF - Access to product.</li>
        <li>Word - Access to a Word version of scoresheets. For International Protocols, access to a Word version of the full protocol.</li>
        <li>Excel – Access to excel version of scoresheets.</li></ul>`,
      },
    },
    {
      id: 3,
      helper: {
        title: "New Template",
        content: `<p>Add Audit Name, share function, dates. Facility and Facility Addresses are optional. Open the product and choose modules needed for Audit or Self-Assessment. SAVE.</p>`,
      },
    },
    {
      id: 4,
      helper: {
        title: "Share Template",
        content:
          "<p>Allows you to share your template with all licensed users. Choose either <b>View</b> or <b>Edit</b></p>",
      },
    },
    {
      id: 5,
      helper: {
        title: "Build Applicability",
        content: "Answer applicability screening questions.",
      },
    },
    {
      id: 6,
      helper: {
        title: "Check N/A",
        content: "Check <b>N/A</b> to any irrelevant rulebooks.",
      },
    },
    {
      id: 7,
      helper: {
        title: "Build Xcelerator",
        content: `<p>Moves applicable audit statements into the Xcelerator file.
        An email will be sent once completed and an icon will highlight on the edit template page.</p>`,
      },
    },
    {
      id: 8,
      helper: {
        title: "Pocket Reference",
        content: `<p>Gives you access to your EHS products and allows you to navigate and search the rulebooks and state differences.
        </p><p><b>Access online: </b>Start by first choosing a publication. Continue search by next choosing a module or enter a key word in Search. Add State differences at any time.
        </p><p><b>Access through a mobile app: </b>It can be accessed from any mobile device and can be found in App Store under Specialty Technical Publishers.
         Use your email address and your STP site password to gain access.</p><p>Start by choosing a publication.</p>`,
      },
    },
    {
      id: 9,
      helper: {
        title: "Build RegRegister",
        content: `<p>Builds an excel list of all relevant regulatory citations
        included in that specific Template.</p>`,
      },
    },
    {
      id: 10,
      helper: {
        title: "View RegRegister",
        content: `<p>Allows you to view the list of all relevant regulatory citations
        included in that specific Template</p>`,
      },
    },
    {
      id: 11,
      helper: {
        title: "Build for Partner",
        content: `<p>It moves applicable audit statements to the EMIS partner of choice</p>`,
      },
    },
    {
      id: 12,
      helper: {
        title: "Custom Questions",
        content: `<p>Can be added to your template and uploaded into the Xcelerator as part of your Audit
        or Self-Assessment.</p><p><b>New Custom Topic</b> - Add a new Topic and First Sub-Topic, SAVE. Then add <b>question</b>. <i>Citation reference</i>,
        <i>citation link</i> and <i>Guidenotes</i> are optional.</p><p>Click on <b>+</b>, continue adding questions.</p>
        <p>Once you have completed entering your custom questions, you can click on button <b>New Custom Topic</b> to add custom topic or on <b>+</b> to add
        new Sub-Topic.</p>
        <p>To edit, click on Sub-Topic name and make changes, additions, deletions. You may also remove Sub-Topics and Topics. Topics will be removed once all Sub-Topics
         are deleted.</p>`,
      },
    },
    {
      id: 13,
      helper: {
        title: "Ranking & Scoring",
        content: `<h4>Allows you to customize scoring system that can be used in the Xcelerator tool for your Audit or Self-Assessment.</h4>
        <p>+ Add new custom template. Add template name, check Make this your Active Template. If you do not check this, the customization will NOT carry through to the Xcelerator tool.
        Option to Not share with Company. SAVE template.</p>
        <p>Audit Scoring and Severity Ranking – add scoring element and score amount. Hit +. Continue adding until complete.</p>
        <p>Can change colour scheme, edit or delete.</p>
        <p>Can delete Custom scoring template selecting template name and clicking on delete.</p>`,
      },
    },
    {
      id: 14,
      helper: {
        title: "AuditHub <br>&copy; 2026 STP ComplianceEHS",
        content: `
        <h4>Version 1.4.0 Release Notes - July 15, 2026</h4>
                <ul  class="circleList">
                    <li>New and improved STP ComplianceEHS Support Center. The Support Center contains help articles, videos, and release notes for STP RegHub and AuditHub. It can also be used to log and track the status of support requests.</li>
                    <li>UI improvements to clearly indicate when a protocol subscription has expired and the product is disabled.</li>
                    <li>Bug Fixes and Miscellaneous Items.</li>
                </ul>
        <h4>Version 1.3.1 Release Notes - April 30, 2026</h4>
                <ul  class="circleList">
                    <li>Fix screen issues in RegApply on small screens.</li>
                    <li>Update help content in Search.</li>
                    <li>A few UI improvements in RegApply.</li>
                </ul>
        <h4>Version 1.3.0 Release Notes - April 16, 2026</h4>
                <ul  class="circleList">
                    <li>Audithub Search tool released.</li>
                    <li>Empty Template Error Message added to RegApply Template builds.</li>
                </ul>
            <h4>Version 1.2.0 Release Notes - Dec 18, 2025</h4>
                <ul  class="circleList">
                    <li>Angular upgrade to V20.</li>
                    <li>Google Maps component removed from Audit Details.</li>
                    <li>Automatic process to sync Reg Compare Data when new product version available.</li>
                </ul>

        `,
      },
    },
    {
      id: 15,
      helper: {
        title: "Building Status",
        content: `
        <ul  class="circleList">
        <li><b>0</b> - Waiting </li>
        <li><b>1</b> - In process / failed but not captured </li>
        <li><b>2</b> - Completed </li>
        <li><b>3</b> - Failed </li>
        <li><b>4</b> - Failed: empty template </li>
        </ul>`,
      },
    },
    {
      id: 16,
      helper: {
        title: "Building Type",
        content: `
        <ul  class="circleList">
        <li><b>X3.0</b> - request for building Xcelerator file.</li>
        <li><b>X3.1</b> - request for building unlocked Xcelerator file.</li>
        <li><b>C3.0</b> - request for building RegRegister file.&nbsp;&nbsp;&nbsp;&nbsp;</li>
        <li><b>csv</b> - request for building CSV file. </li>
        <li><b>reghub</b> - send monitoring request to RegHub. </li>
        <li><b>upgrading</b> - update template to latest protocol version. </li>
        <li><b>velocity</b> - send template data to partner Velocity. </li>
        <li><b>Ideagen EHS</b> - send template data to partner Ideagen EHS(ProcessMap). </li>
        <li><b>intelex</b> - send template data to partner Intelex. </li>
        <li><b>ETQ</b> - send template data to partner ETQ. </li>
        <li><b>SAFETYSTR</b> - send template data to partner SAFETYSTR. </li>
        <li><b>no</b> - for Partner Demo, no real building. </li>
        </ul>`,
      },
    },
    {
      id: 17,
      helper: {
        title: "RegCompare Instructions",
        content: `<ul>
          <li>
            <p>
              Select the jurisdictions and topics you want to compare with federal
              requirements. You can select up to 5 jurisdictions and 15 topics to
              compare. Click <b>Apply</b> to run the comparison. The comparison
              results are organized into rows by topic and into columns by
              jurisdiction. If you have chosen more than one topic, you can
              further refine the results by selecting one of the topics under the
              topic filter. This allows you to focus on a single topic in the
              results. If there are no state differences for a topic, we do not
              include that row in the results.
            </p>
          </li>
          <li>
            <p>
              To save your comparison for future use, click the disk icon in the
              top right corner of the screen. Enter a comparison name and click
              <b>Save</b>. You can access your saved comparisons by expanding the
              <b>Comparison Name</b> drop down in the filter panel and clicking
              <b>Run a Saved Comparison</b>.
            </p>
          </li>
          <li>
            <p>
              To export the results, select the download icon in the top right
              corner of the screen. This will download the results to an Excel
              file which allows you to share the results with others, print, or
              conduct further analysis.
            </p>
          </li>
        </ul>`,
      },
    },
    {
      id: 18,
      helper: {
        title: "AuditHub Search Instructions",
        content: `<ul>
          <li>
            <p>
              Enter a search term and click <b>Apply</b> to find the term within the audit content. You may also filter by jurisdiction, topic, and question type to further refine your search.
            </p>
          </li>
          <li>
            <p>
              <b>Words & Phrases:</b> The Search tool supports connectors to refine multi-word searches. Use spaces, commas, pipes, or quotes to control results:
            </p>
            <ul>
              <li>Injury Illness → Search results containing both words</li>
              <li>Injury, Illness → Search results containing both words</li>
              <li>Injury | Illness → Search results containing either word</li>
              <li>"Injury Illness" → Exact match of the phrase only</li>
            </ul>
          </li>
          </br>
          <li>
            <p>
              The tool also supports singular and plural nouns and verb tenses.
            </p>
          </li>
          <li>
            <p>
              The Search results show the name of the Product, Rulebook, Section, and Paragraph number (for Rulebook Statements) where the search results come from.  The regulatory citation and link to full text is provided where available.  Click <b>Expand</b> to show the full audit statement and Guide Note.
            </p>
          </li>
          <li>
            <p>Within the Search results, click the top line of each result to show the complete text of the product.  The Rulebook where the result comes from is highlighted.  Use this to see the full context of how a term or topic is regulated and presented in STP content.
            </p>
          </li>
        </ul>`,
      },
    },
  ];
  public static STATES: { code: string; name: string }[] = [
    { code: "AK", name: "ALASKA" },
    { code: "AL", name: "ALABAMA" },
    { code: "AR", name: "ARKANSAS" },
    { code: "AZ", name: "ARIZONA" },
    { code: "CA", name: "CALIFORNIA" },
    { code: "CO", name: "COLORADO" },
    { code: "CT", name: "CONNECTICUT" },
    { code: "DE", name: "DELAWARE" },
    { code: "FL", name: "FLORIDA" },
    { code: "GA", name: "GEORGIA" },
    { code: "HI", name: "HAWAII" },
    { code: "IA", name: "IOWA" },
    { code: "ID", name: "IDAHO" },
    { code: "IL", name: "ILLINOIS" },
    { code: "IN", name: "INDIANA" },
    { code: "KS", name: "KANSAS" },
    { code: "KY", name: "KENTUCKY" },
    { code: "LA", name: "LOUISIANA" },
    { code: "MA", name: "MASSACHUSETTS" },
    { code: "MD", name: "MARYLAND" },
    { code: "ME", name: "MAINE" },
    { code: "MI", name: "MICHIGAN" },
    { code: "MN", name: "MINNESOTA" },
    { code: "MO", name: "MISSOURI" },
    { code: "MS", name: "MISSISSIPPI" },
    { code: "MT", name: "MONTANA" },
    { code: "NC", name: "NORTH CAROLINA" },
    { code: "ND", name: "NORTH DAKOTA" },
    { code: "NE", name: "NEBRASKA" },
    { code: "NH", name: "NEW HAMPSHIRE" },
    { code: "NJ", name: "NEW JERSEY" },
    { code: "NM", name: "NEW MEXICO" },
    { code: "NV", name: "NEVADA" },
    { code: "NY", name: "NEW YORK" },
    { code: "OH", name: "OHIO" },
    { code: "OK", name: "OKLAHOMA" },
    { code: "OR", name: "OREGON" },
    { code: "PA", name: "PENNSYLVANIA" },
    { code: "PR", name: "PUERTO RICO" },
    { code: "RI", name: "RHODE ISLAND" },
    { code: "SC", name: "SOUTH CAROLINA" },
    { code: "SD", name: "SOUTH DAKOTA" },
    { code: "TN", name: "TENNESSEE" },
    { code: "TX", name: "TEXAS" },
    { code: "UT", name: "UTAH" },
    { code: "VA", name: "VIRGINIA" },
    { code: "VT", name: "VERMONT" },
    { code: "WA", name: "WASHINGTON" },
    { code: "WI", name: "WISCONSIN" },
    { code: "WV", name: "WEST VIRGINIA" },
    { code: "WY", name: "WYOMING" },
  ];
}
